import {init, collectResource} from '@enos/dpl/lib/locale/localeUtils';

init(collectResource(require.context('~/locale', false, /\.js$/)));
